export default __webpack_public_path__ + "static/media/flattop-dude-arms-crossed-concerned.6a0a07d7.png";